import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import AOS from 'aos'
import 'aos/dist/aos.css'

import '../src/assets/styles/typografia.css'

import 'bootstrap'
import './plugins/bootstrap-vue'
import 'animate.css'

import Components from '@/components'
Vue.use(Components)

import VueNumber from 'vue-number-animation'
Vue.use(VueNumber)

import VueCarousel from 'vue-carousel'
Vue.use(VueCarousel)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: (h) => h(App),
  mounted() {
    AOS.init()
  },
}).$mount('#app')
